export const nl = require('./nl.json')
export const en = require('./en.json')